import type { MaterialsTextResponse } from './api';

export class SessionMaterialDefinitionError extends Error {}

export function applySessionMaterialDefinition<T extends object>(details: T, version?: number | null): T & { material_definition_version?: number } {
  if (version == null) return details;
  if (version !== 1) throw new SessionMaterialDefinitionError('Session material definition is unsupported.');
  return { ...details, material_definition_version: version };
}

export async function loadSessionReferenceMaterials(
  fetcher: (interviewId: string, sessionId?: string) => Promise<MaterialsTextResponse>,
  interviewId: string, sessionId?: string, version?: number | null
): Promise<MaterialsTextResponse> {
  applySessionMaterialDefinition({}, version);
  if (version === 1 && !sessionId) throw new SessionMaterialDefinitionError('Session material identity is missing.');
  try {
    const value = await fetcher(interviewId, sessionId);
    if (version === 1 && (value.definition_version !== 1 || value.session_id !== sessionId
      || typeof value.combined_text !== 'string' || !Array.isArray(value.materials)
      || value.materials_count !== value.materials.length)) {
      throw new SessionMaterialDefinitionError('Session material definition is missing or invalid.');
    }
    return value;
  } catch (error) {
    if (version === 1) throw new SessionMaterialDefinitionError('Accepted interview materials could not be loaded.');
    throw error;
  }
}
